import {
  PharmacyCountsBox,
  PharmacyRow,
  GreenOrdersCountLabel,
  RedOrdersCountLabel,
  GreyOrdersCountLabel,
} from './styles';
import PharmacyName from '../../../PharmacyNotes/PharmacyName';

const OrderCountPerPharmacy = ({ items, onSelect }) => (
  <PharmacyCountsBox>
    {items.map(item => (
      <PharmacyRow key={item._id} onClick={() => onSelect(item._id)}>
        <PharmacyName
          pharmacyName={item.pharmacy_name || 'Unassigned'}
          pharmacyId={item._id || 'unassigned'}
          hidePin
        />
        <div style={{ display: 'flex', gap: '10px' }}>
          {item.count_rag_status_green !== undefined && (
            <GreenOrdersCountLabel disabled={!item.count_rag_status_green}>
              {item.count_rag_status_green}
            </GreenOrdersCountLabel>
          )}
          {item.count_rag_status_red !== undefined && (
            <RedOrdersCountLabel disabled={!item.count_rag_status_red}>
              {item.count_rag_status_red}
            </RedOrdersCountLabel>
          )}
          {item.count_rag_status_green === undefined && (
            <GreyOrdersCountLabel disabled={!item.total_orders}>
              {item.total_orders}
            </GreyOrdersCountLabel>
          )}
        </div>
      </PharmacyRow>
    ))}
  </PharmacyCountsBox>
);

export default OrderCountPerPharmacy;
